var numeral = require('numeral');

import * as common from './common-modules.js';
import * as item from './item.js';
import * as estimationOrder from './estimation-order.js';
import * as mypage from './mypage.js';
import * as order from './order.js';
import EstimateTypeSelecter from './modules/estimate-type-selector.js';

$(function () {

  /*
    アンカーメニュー
    グロナビドロップメニュー
    トップ・商品選択サイドエリア
  */
  common.anchorMenu();
  common.gnavDrop();
  common.asideSubNav();

  //商品選択絞り込み
  item.visibleColorFilter();
  item.visibleFilterIcon();

  //汎用モーダル
  common.commonModal();

  //カラー展開モーダル
  item.colorsModal();

  /*
    ページトップボタン
    パネルタイプのラジオボタン
    もっと読む
    汎用チェックボックスアコーディオン
    汎用ラジオアコーディオン
    一つのみ選択チェックボックス
  */
  common.topBtn().onEvt();
  common.panelRadioSelected();
  common.readMoreAccd().onEvt().initial();
  common.radioSwitchAccordion();
  common.checkboxAccordion();
  common.singleCheck();

  common.selectToggleContent();
  common.switchContentSelect();
  common.initTippy();

  //見積り方法選択モーダル
  EstimateTypeSelecter();

  //見積り発注系画面
  estimationOrder.methodBox();
  estimationOrder.designSizeUserInterface();
  estimationOrder.designSizeInput();
  $('.js-thumb-select-wrap').thumbPull();
  estimationOrder.optionSettingBoxHover();
  estimationOrder.inputNumIncrAndDecr();
  estimationOrder.printColorSelect();
  estimationOrder.colorCodeSelect();

  // 発注手続き画面
  order.updaqteDeliveryDate();

  //テーブル内アコーディオン
  common.nextRowAccordion();

  //紙芝居
  common.kamishibai().initialize($('.js-replace-contents')).bindClick();

  //発注画面
  estimationOrder.inputFromSavedDirect();
  estimationOrder.switchColorChangePattern();

  mypage.comparisonItem().hideItem().itemImgSlide();

  //小さい単位で共通
  common.switchContentRadio(
    $('.js-switch-content-radios'),
    $('.js-switch-content-parent'),
    $('.js-switch-content-target')
  );

  common.switchContentRadio(
    $('.js-switch-apply-radios'),
    $('.js-switch-apply-parent'),
    $('.js-switch-apply-target')
  );

  common.spVerticalRowAlignCell();
  common.switchPasswordDisplay();
  common.switchHashBySelect();

  //チェックボックス全選択/解除
  common.checkAll();
  //問い合わせ同意
  common.agreeCheckScroll();
  common.agreeCheck();
  common.agreeCheckAll();

  common.oneClickForm();

  common.bodyPaddingTop().set();

  //---------------------------//
  //ブログパーツ用機能
  //---------------------------//

  //youtubeパーツ
  var videoControl = function () {
    var $btn = $(".js-close-video");

    function videoControl(action, target) {
      target.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
    }

    $btn.on("click", function () {
      var $videoArea = $(".js-recommend-video");
      var $thisVideo = $(this).closest($videoArea);
      var videoNumber = $videoArea.index($thisVideo);
      var $playerWindow = $('.js-video-player')[videoNumber].contentWindow;

      videoControl("stopVideo", $playerWindow);
      $(this).closest($videoArea).remove();
    });
  }

  //アンカーリンクパーツ
  var partsAnchorMenu = (function(){
    var $categoryNav = $('.js-category-nav');
    var $pcFixedHeader = $('.js-pc-header-content');
    var $spFixedHeader = $('.js-sp-hd-middle');

    $(".js-anchor-links a").click(function(){
      var target = $(this.hash);
      if (!target.length) {
        return false;
      }
      var targetPos = target.offset().top;
      if(common.Page.isTab()){
        $('html,body').animate({scrollTop: targetPos - $spFixedHeader.outerHeight()});
      }else{
        $('html,body').animate({scrollTop: targetPos - $pcFixedHeader.outerHeight()});
      }
    });
  })();

  //ギャラリーパーツ
  var setGalleryAttr = (function(){
    $('.js-gallery-list').each(function(i){
      var $self = $(this);
      var galleryIndex = i;
      $(this).find('a').each(function(i){
        var imgPath = $(this).find('img').attr('src');
        var title = $(this).attr('title');
        $(this).attr({
          'href': imgPath,
          'data-lightbox': 'gallery-parts-' + galleryIndex,
          'data-title': title
        })
      });
    });
    lightbox.option({
      'resizeDuration': 200,
      'wrapAround': true
    });
  })();

  //スライダーパーツ
  var Partsbanners = (function () {
    var init = function () {
      var el = '.js-main-banners';
      var slideLength = $(".swiper-slide", el).length;
      var hasSingleSlide = slideLength === 1;
      var startSlideNum = $(el).hasClass("startSlideRandom") ? Math.floor(Math.random() * slideLength) : 0;
      new Swiper(el, {
        centeredSlides: true,
        spaceBetween: $(el).hasClass("blogparts_element") ? 0 : 40,
        autoplay: hasSingleSlide ? false : {
          delay: 8000,
          disableOnInteraction: false
        },
        loop: !hasSingleSlide,
        speed: 400,
        slidesPerView: 'auto',
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.js-main-banners-swiper-button-next',
          prevEl: '.js-main-banners-swiper-button-prev',
        },
        simulateTouch: false, // true指定でスワイプ機能ON
        initialSlide: startSlideNum,
        onInit: function (swiper) {

          if (!hasSingleSlide) {
            $(swiper.container).addClass("has-pagination");

            if (!common.Page.isSp()) {
              $(swiper.nextButton).show();
              $(swiper.prevButton).show();
            }
          }
        },
        onPaginationRendered: function (swiper) {
          if (hasSingleSlide) {
            $(swiper.bullets).hide();
          }
        }
      })
    };
    return {
      init: init
    };
  }());


  //---------------------------//

  var resizeAdjust = (function(){
    var timer = false;
    $(window).resize(function() {
      /*textLineCut.all();*/
      if (timer !== false) {
        clearTimeout(timer);
      }
      timer = setTimeout(function() {
        /*textLineCut.all();*/
      }, 200);
    }).trigger('resize');
  })();

  //---------------------------//

  common.mainSlider().init();
  item.itemSlider().setThumbImg().init();
  /*textLineCut.all();*/
  common.topBtn().display().position();
  Partsbanners.init();
  common.fixFooter();
  common.header().setSpMenuEvent();
  item.itemSearchToggle().onEvt().mediaDisplay();
  common.setAccordion('.js-accd-trig');
  estimationOrder.qtCalcMod.quantityOperation($('.js-qt-calc'))
    .quantityClear().rowMatchHeight()
    .deleteSelf().onModalOperate().initialSetting($('.js-qt-calc-wrap'));

  //仕上げ加工オプション ネーム・ピスネーム・下げ札付け参考画像データインプット
  common.fileInputMod($('.js-nametag-reference-input'), ['image/jpeg', 'image/png', 'image/vnd.adobe.photoshop', 'application/postscript', 'application/pdf']);

  // プリントカラーの入力・デザインデータ入稿イメージ画像アップロード
  common.fileInputMod($('.js-print-color-image-input'), ['image/jpeg', 'image/png', 'image/vnd.adobe.photoshop', 'application/postscript', 'application/pdf']);

  $(window).on('resize', function(){
    common.topBtn().display().position();
    common.fixFooter();
    common.header().setSpPadding();
    common.spVerticalRowAlignCell();
    common.bodyPaddingTop().set();
    common.fixedSideMenuByScroll().positioning();
    item.itemSearchToggle().mediaDisplay();
    item.stockToEstimate().display();
    item.detailToEstimate().display();
    common.readMoreAccd().resized();
    estimationOrder.qtCalcMod.rowMatchHeight();
    common.fixedAsideByScroll().positioning();
    mypage.contactHistoryTxtCut();
    mypage.comparisonItem().matchHeight();
  }).trigger('resize');

  $(window).on('scroll', function(){
    common.topBtn().display().position();
    item.stockToEstimate().display();
    item.detailToEstimate().display();
    common.fixFooter();
    common.fixedAsideByScroll().positioning();
    common.fixedSideMenuByScroll().positioning();
    /*header().gnavFix();*/
  }).trigger('scroll');

  $(window).on('load', function(){
    $(this).trigger('resize');
  });

  //お問い合わせフォーム二度押し防止
  $("form").submit(function () {
    $(".submit").prop("disabled", true);
  });

  //redirect into another page
  window.redirectUrl = function(theElement) {
    window.location.href = $(theElement).find(':selected').attr('url');
  }

  //不良品返送予定日入力datepicker
  flatpickr.l10ns.ja.firstDayOfWeek = 0;
  flatpickr('.js-datepicker-input', {
    altInput: true,
    locale: "ja",
    altFormat: 'Y年m月d日',
    disableMobile: true
  });

  // readonly または disabled 対応
  $(document).on('click selectstart keydown mousedown', 'form input, form select, form textarea, a, form button, form datalist', function () {
     // 自分自身に readonly 属性または disabled クラスはあるか？
     if ($(this).filter('[readonly]').length || $(this).hasClass('disabled')) {
         return false;
     }

     // closest に readonly 属性または disabled クラスはあるか？
     if ($(this).closest('[readonly]').length || $(this).closest('.disabled').length) {
        return false;
     }
  });

  //---------------------------//
  // ヘッダのモーダルボタン（スケジュール自動計算）
  //---------------------------//
  $(".js-hd-modalbtn").on("click", function () {
    $(".modal-schedule").show();
  });

  $(".js-modal-schedule-bg, .js-modal-schedule-close, .js-modal-schedule-close-btm").on("click", function () {
    $(".modal-schedule").hide();
  });
});
